/* eslint-disable */

import * as THREE from 'three'

export default {

    uniforms:
    {
        'tDiffuse': { type: 't', value: new THREE.Texture() },
        'uTileSize': { type: 'vec2', value: new THREE.Vector2(80, 90) },
        'uViewportSize': { type: 'vec2', value: new THREE.Vector2(1615.0, 1086.0) },
        'uCursorPosition': { type: 'vec2', value: new THREE.Vector2(0.5, 0.5) },
        'uRadius': { type: 'f', value: 300 },
        'uTileOffset': { type: 'f', value: 140 },
    },

    vertexShader: `
        varying vec2 vUv;

        void main()
        {
            vUv = uv;
            gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
        }
    `,

    fragmentShader: `
        uniform sampler2D tDiffuse;
        uniform vec2 uTileSize;
        uniform vec2 uViewportSize;
        uniform vec2 uCursorPosition;
        uniform float uRadius;
        uniform float uTileOffset;

        varying vec2 vUv;

        highp float random(vec2 co)
        {
            highp float a = 12.9898;
            highp float b = 78.233;
            highp float c = 43758.5453;
            highp float dt = dot(co.xy ,vec2(a,b));
            highp float sn = mod(dt,3.14);
            return fract(sin(sn) * c);
        }

        vec2 getTileCoord()
        {
            float viewportRatio = uViewportSize.x / uViewportSize.y;
            vec2 tilesCount = vec2(floor(uViewportSize.x / uTileSize.x), floor(uViewportSize.y / uTileSize.y));
            float x = vUv.x;
            float y = vUv.y;
    
            float tileAngleOffset = 1.0 / tilesCount.x;

            y -= mod(x, tileAngleOffset) * viewportRatio / 2.0 - tileAngleOffset;

            vec2 coord = vec2(floor(x * tilesCount.x) / tilesCount.x, floor(y * tilesCount.y) / tilesCount.y);

            return coord;
        }

        void main()
        {
            // Viewport ratio
            float viewportRatio = uViewportSize.x / uViewportSize.y;

            // Radius
            float radius = uRadius / uViewportSize.x;

            // Calculate tile center coordinates
            vec2 tileCoord = getTileCoord();

            // Cursor
            float cursorIntensity = 1.0 - distance(vec2(tileCoord.x, (tileCoord.y - uCursorPosition.y) / viewportRatio + uCursorPosition.y), uCursorPosition) / radius;
            cursorIntensity = clamp(cursorIntensity, 0.0, 1.0);

            // Tile offset
            float randomDirection = random(tileCoord);
            float randomStrength = random(tileCoord + vec2(2.1684754, 3.546842));
            vec2 tileOffset = vec2(uTileOffset / uViewportSize.x, uTileOffset / uViewportSize.y);
            vec2 maxOffset = vec2(cos(randomDirection * 3.14 * 2.0) / (uViewportSize.x / uTileOffset), sin(randomDirection * 3.14 * 2.0) / (uViewportSize.x / uTileOffset)) * randomStrength;
            vec2 offset = maxOffset * cursorIntensity;

            // Color
            vec4 color = texture2D(tDiffuse, vUv + offset);
            // vec4 color = vec4(cursorIntensity, 0.0, 0.0, 1.0);
            // vec4 color = vec4(offset * uTileOffset, 0.0, 1.0);

            // Reflect
            float reflectStrength = clamp(((1.0 - randomDirection) * 2.0 - 1.0), 0.0, 1.0) * 0.25;
            color.rgb += vec3(88.0 / 256.0, 125.0 / 256.0, 152.0 / 256.0) * reflectStrength * cursorIntensity;

            gl_FragColor = color;
        }
    `
}


// WEBPACK FOOTER //
// ./src/scripts/components/page-home/Background/Shaders/Tiles.js